module.exports = __webpack_public_path__ + "static/media/ClassLogo.2169a6f5.png";